import axios from 'axios';
import { Fragment, useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { FaLock, FaPencilAlt } from 'react-icons/fa'
import { getHeaderForAxios, getToken } from '../../common/getLocalStorageData'
import IUser from '../../interfaces/user'
import { PROFILE_CHANGEPASSWORD, SIDE_MENU_PROFILE } from '../../constant/menuAndProfile';
import { IReduxStateData } from '../../interfaces/redux';
import { useSelector } from 'react-redux';

const errorFieldList = {
    password: "",
    newPassword: "",
    confirmPassword: "",
    submit: false
}
export const ChangePassword = (props: IUser | any) => {
    const [isPageEdit, setIsPageEdit] = useState(false);
    const [errorList, setErrorList] = useState(errorFieldList);
    const [responseMessage, setResponseMessage] = useState({
        "message": "",
        "type": ""
    })
    const [user_uuid, setUserUuid] = useState(props.uuid ? props.uuid : "");
    const [password, setPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [redirectToLoginPage, setRedirectToLoginPage] = useState(
        getToken() ? false : true
    );
    const globalState = useSelector((state: IReduxStateData) => state);
    const selectedLanguage = globalState?.selectedLang;
    const changePasswordInput = (e: any) => {
        if (errorList.submit && !errorList.password) {
            let data = { ...errorList };
            if (e.target.value) {
                data["password"] = "";
                setErrorList(data);
            }
        }
        setPassword(e.target.value);
    };
    const changeNewPasswordInput = (e: any) => {
        if (errorList.submit && !errorList.newPassword) {
            let data = { ...errorList };
            if (e.target.value) {
                data["newPassword"] = "";
                setErrorList(data);
            }
        }
        setNewPassword(e.target.value);
    };
    const changeConfirmPasswordInput = (e: any) => {
        if (errorList.submit && !errorList.confirmPassword) {
            let data = { ...errorList };
            if (e.target.value && newPassword === e.target.value) {
                data["confirmPassword"] = "";
                setErrorList(data);
            }
        }
        setConfirmPassword(e.target.value);
    };
    const submitSaveData = async () => {
        let data = {
            newPassword: newPassword, oldPassword: password, user_uuid: user_uuid
        }
        await axios.post(process.env.REACT_APP_API_URL + '/auth/change-password', data, { headers: getHeaderForAxios() })
            .then(function (response) {
                if (response.data && response.data.message) {
                    setIsPageEdit(false)
                    setResponseMessage({
                        message: response.data.message,
                        type: "success",
                    });
                    setTimeout(() => {
                        setResponseMessage({ message: "", type: "" });
                        setPassword("");
                        setNewPassword("");
                        setConfirmPassword("");
                    }, 10000);
                }
            })
            .catch(function (error) {
                if (error.response && error.response.data && error.response.data.message) {
                    setResponseMessage({ message: error.response.data.message, type: "error" });
                    setTimeout(() => {
                        setResponseMessage({ message: "", type: "" });
                    }, 10000);
                }
            })
    }
    const checkValidationSubmit = (e: any, isSubmit: boolean = true) => {
        const errorData = { ...errorFieldList };
        let isValidateForm = true;
        if (!password) {
            isValidateForm = false;
            errorData['password'] = "Please enter old password"
        }
        if (!newPassword) {
            isValidateForm = false;
            errorData['newPassword'] = "Please enter new password"
        }
        if (!confirmPassword) {
            isValidateForm = false;
            errorData['confirmPassword'] = "Please enter confirm password"
        }
        if (confirmPassword && newPassword && newPassword !== confirmPassword) {
            isValidateForm = false;
            errorData['confirmPassword'] = "Please enter correct password"
            errorData['newPassword'] = "Please enter new password"
        }
        if (isValidateForm && isSubmit) {
            submitSaveData();
            setErrorList(errorData);
        } else {
            errorData['submit'] = true;
            setErrorList(errorData)
        }
        // setToggleFlag(!toggleFlag)
    }
    return (
        <Fragment>
            {/* <Sonnet /> */}
            <div className='right-side-header-main'>
                <div className='right-side-header'>{SIDE_MENU_PROFILE[selectedLanguage].change_password}</div>
                {/* <span className='right-side-header-icon'><FaPencilAlt /></span> */}

                {
                    !isPageEdit ?
                        <span className='right-side-header-icon' onClick={() => setIsPageEdit(true)}><FaPencilAlt /></span> :
                        null
                }
            </div>
            <hr />
            <Row className='right-side-wrapper'>
                <Col sm={12} className="user-form-div">
                    {responseMessage.message ? (
                        <div
                            className={
                                responseMessage.type === "success"
                                    ? "form-response success"
                                    : "form-response error"
                            }
                        >
                            {responseMessage.message}
                        </div>
                    ) : null}
                    <Form className='mr-0 mr-sm-5'>
                        <Fragment>
                            <Form.Group className={`form-group ${password ? "focus" : ""} ${errorList.submit ? errorList.password ? "field-group-error" : "field-group-success" : ""}`} controlId="formPassword">
                                <Form.Label>{PROFILE_CHANGEPASSWORD[selectedLanguage].old_password}</Form.Label>
                                <Form.Control type="password" autoComplete="new-password" value={password} onChange={(e) => changePasswordInput(e)} className={`${!isPageEdit ? "disabled" : ""}`} disabled={!isPageEdit ? true : false} />
                                <span className="input-append">
                                    <FaLock />
                                </span>
                            </Form.Group>
                            <Form.Group className={`form-group ${newPassword ? "focus" : ""} ${errorList.submit ? errorList.newPassword ? "field-group-error" : "field-group-success" : ""}`} controlId="formNewPassword">
                                <Form.Label>{PROFILE_CHANGEPASSWORD[selectedLanguage].new_password}</Form.Label>
                                <Form.Control type="password" autoComplete="new-password" value={newPassword} onChange={(e) => changeNewPasswordInput(e)} className={`${!isPageEdit ? "disabled" : ""}`} disabled={!isPageEdit ? true : false} />
                                <span className="input-append">
                                    <FaLock />
                                </span>
                            </Form.Group>
                            <Form.Group className={`form-group ${confirmPassword ? "focus" : ""} ${errorList.submit ? errorList.confirmPassword ? "field-group-error" : "field-group-success" : ""}`} controlId="formConfirmPassword">
                                <Form.Label>{PROFILE_CHANGEPASSWORD[selectedLanguage].confirm_new_password}</Form.Label>
                                <Form.Control type="password" autoComplete="new-password" value={confirmPassword} onChange={(e) => changeConfirmPasswordInput(e)} className={`${!isPageEdit ? "disabled" : ""}`} disabled={!isPageEdit ? true : false} />
                                <span className="input-append">
                                    <FaLock />
                                </span>
                            </Form.Group>
                            {isPageEdit ?
                                <Form.Group className='form-group'>
                                    <Button type="button" className="font-semibold btn btn-save d-inline w-75"
                                        onClick={(e) => {
                                            checkValidationSubmit(e, true)
                                        }}
                                    >
                                        {SIDE_MENU_PROFILE[selectedLanguage].save}
                                    </Button>
                                    <Button type="button" className="font-semibold btn btn-save d-inline w-25 cancel-btn"
                                        onClick={(e) => {
                                            setIsPageEdit(false)
                                        }}
                                    >
                                        {SIDE_MENU_PROFILE[selectedLanguage].cancel}
                                    </Button>
                                </Form.Group>
                                : null
                            }
                        </Fragment>
                    </Form>
                </Col>
            </Row>
        </Fragment>
    )
}